import { useState } from "react"
import { useCommitFunction } from "routes/schedule/compare/use-commit-function"
import { useLegislationFromId } from "routes/schedule/plugins/guidance-tab/guidance-tab.runtime"
import { Box, ListItemText, Typography } from "@mui/material"
import { DifferenceWrapper } from "routes/schedule/compare/differenceWrapper"
import { ListItemBox } from "lib/@components/ListItemBox"
import { PropertyBox } from "lib/@components/property-box"
import { StatusButton } from "routes/schedule/compare/status"
import { AcceptedChanged, IsAccepted } from "event-definitions"
import { noChange } from "lib/@hooks/useRefresh"

export function RemovedGuidance({ guidance }) {
    const [add, setAdd] = useState(false)
    useCommitFunction(
        (target) => {
            // Push the guidance ID in the same type as existing entries to avoid
            // mixed string/number arrays that break future indexOf/findIndex calls.
            // Guard against empty/whitespace strings which Number() coerces to 0.
            const trimmed = `${guidance ?? ""}`.trim()
            if (!trimmed) return
            const numericId = Number(trimmed)
            target.legislation.push(Number.isFinite(numericId) ? numericId : guidance)
        },
        add,
        [guidance]
    )

    const legislation = useLegislationFromId(guidance)
    const accepted = IsAccepted.call({ isAccepted: false, id: "Guidance" })
    AcceptedChanged.after.useRefresh(noChange)

    return (
        !!legislation && (
            <>
                <ListItemBox className="removed-guidance">
                    <PropertyBox spacing={0}>
                        <DifferenceWrapper
                            label={`${add ? "Reinstate" : ""} removed guidance "${legislation.HTML}"`}
                            wrapper={<Box sx={{ py: 1, ml: 0 }} />}
                        >
                            <ListItemBox>
                                <ListItemText
                                    disableTypography
                                    sx={{ flex: 1, pl: 1 }}
                                    primary={
                                        <Box
                                            component="span"
                                            sx={{ textDecoration: !add ? "line-through" : undefined }}
                                        >
                                            {legislation.HTML}
                                        </Box>
                                    }
                                    secondary={
                                        <Box component="span">
                                            <Typography variant="body2">
                                                {add ? "Restored reference" : "Removed reference"}
                                            </Typography>
                                        </Box>
                                    }
                                />
                                {!accepted && (
                                    <StatusButton copied={add} copy={() => setAdd(!add)} revert={() => setAdd(!add)} />
                                )}
                                {!accepted && (
                                    <ListItemText
                                        disableTypography
                                        sx={{ flex: 1, pl: 3 }}
                                        primary={<Box>{legislation.HTML}</Box>}
                                        secondary={
                                            <Box>
                                                <Typography variant="body2">Reference present</Typography>
                                            </Box>
                                        }
                                    />
                                )}
                            </ListItemBox>
                        </DifferenceWrapper>
                    </PropertyBox>
                </ListItemBox>
            </>
        )
    )
}
